import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'Menu',
    //     isTitle: true
    // },
    {
        id: 0,
        label: 'Dashboard',
        icon: 'bx bx-home-circle',
        link: '/dashboard',

    },
  
    // {
    //     id: 2,
    //     label: 'Live GPS Tracking',
    //     icon: 'bx bx-book-content',
    //     link: '/livetracking',
    // },
   
    // {
    //     id: 2,
    //     label: 'POS Monitor',
    //     icon: 'bx bx-file',
    //     link: '/posmonitor',
    // },
    // {
    //     id: 2,
    //     label: 'POS Monitor Details',
    //     icon: 'bx bx-book-content',
    //     link: '/posmonitordetails',
    // },
    // {
    //     id: 2,
    //     label: 'Terminal Status',
    //     icon: 'bx bx-file',
    //     link: '/terminalstatus',
    // },
    // {
    //     id: 2,
    //     label: 'Terminal Status Details',
    //     icon: 'bx bx-book-content',
    //     link: '/terminalstatusdetails',
    // },
  
      {
        id: 1,
        label: "Terminals",
        icon: "mdi mdi-calculator",
        link: "/terminal",
      },
      {
        id: 11,
        label: "Terminal Groups",
        icon: "bx bx-grid-alt",
        link: "/terminal-groups",
      },
      {
        id:17,
        label:'Terminal Footprint',
        icon:"bx bx-map-pin",
        link:"/terminal-footprint"
      },
      {
        id: 18,
        label: 'Service Requests',
        icon: 'bx bx-user-voice',
        link: '/servicerequest',
    },
     {
        id: 44,
        label: 'Business Applications',
        icon: 'bx bx-carousel',
        link: '/business-apps',
    },
     {
        id: 58,
        label: 'strategies',
        icon: 'bx bx-bluetooth',
        link: '/strategies',
    },
    {
      id: 20,
      label: "Logs",
      icon: "bx bx-pulse",
      subItems:[
          {
              id: 21,
              label: "Transactions ",
              icon: "bx bx-lock",
              link: "/transactionstatus",
            },
            {
              id: 22,
              label: "Settlements",
              icon: "bx bx-file",
              link: "/settlment",
            },
            {
              id: 23,
              label: "TMS ",
              icon: "bx bxs-cube",
              link: "/tmslist",
            },
            {
              id: 24,
              label: "Terminal Messages ",
              icon: "bx bxs-cube",
              link: "/messageList",
            },
            {
              id: 25,
              label: "Terminal Actions ",
              icon: "bx bxs-cube",
              link: "/actionList",
            },
            {
              id: 26,
              label: 'Radius Boundary Logs',
              icon: 'bx bx-mao',
              link: '/boundary-logs',
            },
             {
              id: 53,
              label: 'Application Installations',
              icon: 'bx bx-mao',
              link: '/installation-logs',
            },
            {
              id: 54,
              label: 'Application Configurations',
              icon: 'bx bx-mao',
              link: '/configuration-logs',
            },
            {
              id: 55,
              label: 'Terminal Strategy ',
              icon: 'bx bx-mao',
              link: '/strategy-logs',
            },
            {
              id: 56,
              label: 'Download speed limit ',
              icon: 'bx bx-mao',
              link: '/speedlimit-logs',
            },
            {
              id: 57,
              label: 'Application Log Downloads ',
              icon: 'bx bx-mao',
              link: '/log-downloads',
            },
        ]
      },
      {
        id: 27,
        label: "Settings",
        icon: "bx bx-cog",
        link: "/terminalDiagnostics",
        subItems:[
            {
                id: 28,
                label: 'Service',
                icon: 'bx bx-user-voice',
                link: '/servies',
            },
            
            {
              id: 29,
              label: 'Service Status',
              icon: 'bx bx-user-voice',
              link: '/service-status',
          },
          
            
          {
            id: 30,
            label: 'Messages Types',
            icon: 'bx bx-user-check',
            link: '/messagetype',
          },
          {
            id: 31,
            label: 'Action Items',
            icon: 'bx bx-user-check',
            link: '/action-items',
          },
          {
            id: 32,
            label: 'Radius Boundary Setting',
            icon: 'bx bx-mp',
            link: '/radius-boundary',
          },
          
        ]
      },
      // {
      //   id: 2,
      //   label: 'Reports',
      //   icon: 'bx bx-stats',
      //   link:'/reports'
      // }
      {
        id: 33,
        label: "Reports",
        icon: "bx bx-stats",
        subItems:[
            {
                id: 34,
                label: "Transactions ",
                icon: "bx bx-lock",
                link: "/reportsTransactions",
              },
              {
                id: 35,
                label: "Settlements",
                icon: "bx bx-file",
                link: "/reportsSettlement",
              },
              {
                id: 36,
                label: "TMS ",
                icon: "bx bxs-cube",
                link: "/reportsTMS",
              },
        ],
        
      },
      { id: 37,
        label: 'User Management',
        icon: 'bx bx-user-check',
        subItems:[
           {
                id: 37,
                label: 'Users',
                icon: 'bx bx-user-check',
                link: '/usermanagment',  
            },
             {
                id: 42,
                label: 'User Approvals',
                icon: 'bx bx-user-check',
                link: '/user-approvals',
            },
            {
                id: 43,
                label: 'User Groups',
                icon: 'bx bx-user-check',
                link: '/usergroups',
            }
          ]
          },
          
];

